import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { Preloader } from "@/components/site/Preloader";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { Cursor } from "@/components/site/Cursor";
import { SiteRoutes } from "@/pages/SiteRoutes";

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <div className="grain bg-[#FBFBF9] text-stone-900 min-h-screen">
          <Preloader />
          <ScrollProgress />
          <Cursor />
          <Nav />
          <SiteRoutes />
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-center" />
        </div>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
